import { createSlice } from "@reduxjs/toolkit";

interface EventSeriesState {
  seriesById: Record<number, any>;
}

const EVENT_SERIES_INITIAL: EventSeriesState = {
  seriesById: {},
};

const eventSeriesSlice = createSlice({
  name: "eventSeries",
  initialState: {
    ...EVENT_SERIES_INITIAL,
  },
  reducers: {
    EVENT_SERIES_UPDATE_BULK: (state: EventSeriesState, { payload }: any) => {
      if (!Array.isArray(payload)) {
        return state;
      }

      const seriesById: Record<number, any> = payload.reduce((acc: Record<number, any>, series: any) => {
        acc[series.id] = series;
        return acc;
      }, {});

      return {
        ...state,
        seriesById: {
          ...state.seriesById,
          ...seriesById,
        },
      };
    },
    EVENT_SERIES_UPDATE_SINGLE: (state: EventSeriesState, { payload }: any) => {
      if (!payload?.id) return state;

      return {
        ...state,
        seriesById: {
          ...state.seriesById,
          [payload.id]: payload,
        },
      };
    },
  },
});

const { EVENT_SERIES_UPDATE_BULK, EVENT_SERIES_UPDATE_SINGLE } = eventSeriesSlice.actions;

export { eventSeriesSlice, EVENT_SERIES_UPDATE_BULK, EVENT_SERIES_UPDATE_SINGLE };
